import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../AppButton";
import styles from "./styles.module.css";

interface Props {
  onOk?: () => void;
  onCancel?: () => void;
  buttonOkText?: string;
  disabledOkBtn?: boolean;
  disabledCancelBtn?: boolean;
  onCancelText?: string;
  isWarningButton?: boolean;
  footerClassName?: string;
}

export const ModalBasicFooter = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.footer, props.footerClassName)}>
      {props.onCancel && (
        <AppButton
          buttonType={"outlined"}
          onClick={props.onCancel}
          disabled={props.disabledCancelBtn}
        >
          {props.onCancelText
            ? props.onCancelText
            : t("audio_transcription.cancel_button")}
        </AppButton>
      )}
      {props.onOk && (
        <AppButton
          buttonType={props.isWarningButton ? "outlined" : "contained"}
          onClick={props.onOk}
          disabled={props.disabledOkBtn}
          warning={props.isWarningButton}
        >
          {props.buttonOkText}
        </AppButton>
      )}
    </div>
  );
};
